
/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect } from 'react';
import { passwordCriteria } from '../utils/configs';

const PasswordValidator = ({ showValidation,isValidPassword,passwordMatchError, passwordFields ,empPassword}) => {
  const { newPassword = '', confirmPassword = '' } = passwordFields;
  const activePassword = newPassword.length > 0 ? newPassword : confirmPassword;

  const validations = {
    0: activePassword.length >= 6,
    1: activePassword.length <= 20,
    2: /[A-Z]/.test(activePassword),
    3: /[a-z]/.test(activePassword),
    4: /\d/.test(activePassword),
    5: /[!#$%&?]/.test(activePassword),
    6: /^[A-Za-z0-9!#$%&?]+$/.test(activePassword),
  };

  useEffect(() => {
    const allValid = Object.values(validations).every(Boolean) && confirmPassword === activePassword;
    isValidPassword(!allValid);
    (activePassword.length && activePassword !== confirmPassword && confirmPassword.length > 0)? passwordMatchError(true):passwordMatchError(false);
  }, [passwordFields]);

  return (
    <div className="password-container">
      {(newPassword.length > 0 || confirmPassword.length > 0) && showValidation && (
        <div className={empPassword?"pop-up-cls":"popup"}>
          <ul>
            {passwordCriteria.map((item, index) => (
              <ValidationItem key={index} isValid={validations[index]} label={item} />
            ))}
          </ul>
        </div>
      )}
    </div>
  );
};

const ValidationItem = ({ isValid, label }) => {
  return (
    <li className={isValid ? 'valid' : 'invalid'}>
      {isValid ? '✔️' : '❌'} {label}
    </li>
  );
};

export default PasswordValidator;
